import React from 'react';

interface IWidgetErrorProps {
  message?: string;
}

export const WidgetError = ({
  message = 'Не удалось загрузить результаты',
}: React.PropsWithChildren<IWidgetErrorProps>): JSX.Element => (
  <div className="d-flex justify-content-center mb-4">{message}</div>
);
